import { Component, OnInit } from "@angular/core";
import { ictProjectModel } from "src/app/Models/ictProjectModel.model";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";
import { IctprojectService } from "../services/ictproject.service";
import { Location } from "@angular/common";
import { InfoDialogComponent } from "src/app/components/info-dialog/info-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { AuthServiceService } from "src/app/services/auth-service.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ICTProjectHistory } from "src/app/Models/ictProjectHistoryModel.model";
import { ProjectType } from "src/app/enums/projectType.enum";
import { Notes } from "src/app/Models/notes.model";
import { CommentsDialogComponent } from "src/app/components/comments-dialog/comments-dialog.component";
import {
  AttachmentTypes,
  UploadFileResponse,
} from "../project-detail/project-detail.component";
import { AttachmentsModel } from "src/app/Models/attachments.model";
import { ProjectService } from "../services/projectservice.service";
import { OrganizationService } from "src/app/services/Organization/organization.service";
import { UserRoles } from "src/app/enums/userRoles.enum";
import { environment } from "src/environments/environment";
import { ViewfileComponent } from "src/app/components/viewfile/viewfile.component";
import { SharedSkillService } from "../../skill-repository/shared-skill.service";
import { EmployeeService } from "../../employee-profile/employee-profile.service";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";

@Component({
  selector: "app-ict-project-detail",
  templateUrl: "./ict-project-detail.component.html",
  styleUrls: ["./ict-project-detail.component.css"],
})
export class IctProjectDetailComponent implements OnInit {
  project: any;
  public formData: UntypedFormGroup;
  public contentTypes = ["Corporate Deck", "Industry Deck"];
  public attachmentTypes = AttachmentTypes;
  public uploads: Array<AttachmentsModel>;
  private filesChanged: boolean;
  public signedinUserOrgName = this.auth.getOrganizationName();
  loading = false;
  mode: string;
  title: string;
  projectType = "";
  role = "";
  isView: boolean;
  filteredValues: any[] = [];
  employee: any = {};
  a: any = null;
  users: any;
  flag: any;
  isApproved: boolean;
  isEdit: boolean;
  isPurpose:boolean;
  isTag:boolean;
  isDescription:boolean;
  isAdd: boolean;
  isPending: boolean;
  deliveryOrganizations: any;
  contentType = "Case Studies";
  permissions = {
    canViewNotes: false,
    canAddProject: false,
    canApproveProject: false,
  };
  rejectedToPendingSwitchFlag = false;
  mainUrl = environment.mainUrl;
  base64Image: any;
  logobase64: string | null = null;
  changesAllowedChecked: boolean = true;
  exist: boolean;
  constructor(
    private ictProjectService: IctprojectService,
    private location: Location,
    private matDialog: MatDialog,
    private projectService: ProjectService,
    private organizationService: OrganizationService,
    // tslint:disable-next-line: align
    private auth: AuthServiceService,
    private router: Router,
    private employeeService: EmployeeService,
    public sharedSkillService: SharedSkillService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private toastr: ToastrService
  ) {
    this.uploads = new Array<AttachmentsModel>();
  }

  ngOnInit() {
    this.role = this.auth.getRole();
    
    this.route.queryParams.subscribe((params: Params) => {
      if (params) {
        if (params.isView) {
          this.isView = true;
        }
        if (params.isApproved) {
          this.isApproved = params.isApproved as boolean;
        }
      }
    });
    this.getFilteredValues('');
    this.fetchAllOrganizations();
    this.route.params.subscribe((params: Params) => {
      this.mode = params.id;
      params.id && params.id !== ""
        ? (this.mode = "edit")
        : (this.mode = "add");
      this.mode === "edit"
        ? (this.title = "Edit Project")
        : (this.title = "Add Project");
      if (params.history && params.history === "history") {
        this.projectType = "history";
      } else {
        this.projectType = "";
      }

      this.role !== "Viewer"
        ? (this.permissions.canViewNotes = true)
        : (this.permissions.canViewNotes = false);
      this.role !== "ContentManager" && this.role !== "Viewer"
        ? (this.permissions.canApproveProject = true)
        : (this.permissions.canApproveProject = false);
      if (this.mode === "edit") {
        this.isEdit = true;
        if (this.isView) {
          this.title = "View Project"
        }
        if (this.projectType !== "history") {
          this.getICTProjectById(params.id);
        } else {
          this.getICTProjectHistoryById(params.id);
        }
      }
      else {
        this.isAdd = true
      }
    });
    if (this.projectType === "history") {
      this.project = new ICTProjectHistory();
    } else {
      this.project = new ictProjectModel();
    }

    this.createFormControls();
  }
  toggleChangesAllowed() {
    this.changesAllowedChecked = !this.changesAllowedChecked;
  }
  convertFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    })
  }
  async handleFileInput(files: FileList, fileType) {
    if (files && files.item && files.item(0).size > 25000000) {
      this.showDialog("File size too large please select below 25MB");
      return;
    }
    this.filesChanged = true;
    const attachment = new AttachmentsModel();
    attachment.fileName = files.item(0).name;
    attachment.file = files.item(0);
    attachment.id = fileType;
    if (fileType == 3) {
      let processedFile = await Promise.resolve(this.convertFile(files[0]));
      this.logobase64 = processedFile.toString().split(",")[1];
    }
    if (this.uploads && this.uploads.length) {
      const fileTypeIndex = this.uploads.findIndex((ele) => ele.id == fileType);
      if (fileTypeIndex === -1) {
        this.uploads.push(attachment);
      } else {
        this.uploads[fileTypeIndex] = attachment;
      }
    } else {
      this.uploads.push(attachment);
    }
  }
  createFormControls() {

    this.formData = new UntypedFormGroup({
      purposeOfUsage: new UntypedFormControl(
        this.project.purposeOfUsage ? this.project.purposeOfUsage : "",
        [Validators.required]
      ),
      description: new UntypedFormControl(
        this.project.description ? this.project.description : "",
        [Validators.required, Validators.maxLength(150), Validators.minLength(30)]

      ),
      companyName: new UntypedFormControl(
        this.project.companyName
          ? this.project.companyName
          : this.signedinUserOrgName,
        Validators.required
      ),
      contactPerson: new UntypedFormControl(
        this.project.contactPerson ? this.project.contactPerson : "",
        [Validators.required, Validators.pattern('^[a-zA-Z0-9.]+(?:[ ]+[a-zA-Z0-9.]+)*$')]
      ),

      contentType: new UntypedFormControl(
        this.project.contentType ? this.project.contentType : (this.route.snapshot.url[2].path ? (this.contentTypes.find(x => x == this.route.snapshot.url[2].path) == undefined ? "" : this.contentTypes.find(x => x == this.route.snapshot.url[2].path)) : ""),
        Validators.required

      ),
      changesAllowed: new UntypedFormControl(
        this.changesAllowedChecked ? this.changesAllowedChecked : false
      ),
      restrictedContent: new UntypedFormControl(
        this.project.restrictedContent ? this.project.restrictedContent : false
      ),
      tags: new UntypedFormControl(this.project.tags ? this.project.tags : "",
        [Validators.required, Validators.maxLength(150), Validators.pattern('^[^\\s][a-zA-Z ,.-/]+[a-zA-Z ,.-/]*$')]
    ),

      projectName: new UntypedFormControl(
        this.project.projectName ? this.project.projectName : "",
        [Validators.required, Validators.pattern('^[a-zA-Z]+[a-zA-Z ]*$')]
      ),
      clientLogo: new UntypedFormControl(
        this.project.clientLogo ? this.project.clientLogo : "",
      ),
      logo: new UntypedFormControl(""),
      ppt: new UntypedFormControl(""),
    });

    if (this.isView) {
      this.formData.disable();
    }
    if (this.role != UserRoles.SuperAdmin) {
      this.formData.get("companyName").disable();
    }

    if (this.project.tags) {
      this.formData.patchValue({
        tags: this.project.tags ? this.project.tags.join(", ") : "",
      });
    }
  }

  getICTProjectById(id: any) {
    this.loading = true;

    this.ictProjectService.getICTProjectById(id).subscribe(
      (res) => {
        this.project = res;
        this.createFormControls();
        this.project = res;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "Please try again", class: "text-danger" },
        });
      }
    );
  }

  getICTProjectHistoryById(id: any) {
    this.loading = true;
    this.ictProjectService.getICTProjectHistoryById(id).subscribe(res => {
      this.project = res;

      if (this.project.status === ProjectType.PendingDescription) {
        this.isPending = true;
      }
      if (this.project.status === ProjectType.RejectedDescription) {
        this.rejectedToPendingSwitchFlag = true;
      }
      if (this.project.notes && this.project.notes.length) {
        this.project.notes.forEach(ele => ele.duration = this.getTimeSince(ele.createdOn));
      }
      this.loading = false;
      this.createFormControls();
    }, res => {
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        width: '280px',
        data: { message: 'No project found. Please contact your administrator', class: 'text-danger' }
      });
    });
  }

  getFilteredValues(event: any) {
    const specialCharsRegex = /[#$%^&*_+\-=\[\]{};':"\\|,.<>\/?~]/; 
  
    if (event && specialCharsRegex.test(event)) {
      this.filteredValues = [];
    } else {
      this.employeeService.getEmployeesOnSearch(event).subscribe((res) => {
        this.filteredValues = res.data ? res.data.profiles : [];
      });
    }
  }
  setCurrentEmployee(value: any) {
    this.employee = {}
    this.sharedSkillService.setEmployeeId(value);
    this.getEmployeeDetalis(value)
  }
  Onchange() {
    if (this.flag)
      this.a = this.formData.value
  }
  getEmployeeDetalis(empId?: string) {
    if (!empId)
      empId = this.sharedSkillService.getEmployeeId()

    if (empId) {
      this.loading = true;
      this.employeeService.getEmployeeDetails(empId).subscribe(res => {
        res.data.competencies?.forEach(c => {
          c.subCompetencies?.forEach(s => {
            s.certificates?.forEach(sc => {
              if (sc.status == 2) {
                sc.status = 1;
                sc.plannedDate = sc.expiryDate;
                sc.expiryDate = null;
              }
              return sc
            })
            return s
          })
          return c
        });
        this.employee = res.data;
        this.loading = false;
      }, error => {
        this.loading = false;
      });
    }
  }
  goToHome() {
    this.router.navigate(["/Home"]);
  }
  goToSearch() {
    this.router.navigate(["/Home/KMSPortal"])
  }
  goToProjectContent() {
    this.router.navigate(["/Home/KMSPortal/Project Content"])
  }
  goBack(category: string) {
    this.router.navigate(["/ICT/searchict"], {
      queryParams: { type: category },
    });
  }

  fetchAllOrganizations() {
    this.loading = true;
    this.organizationService.fetchOrganizationsList().subscribe(
      (res) => {
        this.loading = false;
        this.deliveryOrganizations = res;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  assignFromValues() {

    if (this.mode === 'edit') {
      this.project.purposeOfUsage = this.formData.get("purposeOfUsage").value;
      this.project.description = this.formData.get("description").value;
      this.project.companyName = this.formData.get("companyName").value;
      this.project.contactPerson = this.formData.get("contactPerson").value;
      this.project.contentType = this.formData.get("contentType").value;
      this.project.changesAllowed = this.formData.get("changesAllowed").value;
      this.project.restrictedContent = this.formData.get("restrictedContent").value;
      this.project.projectName = this.formData.get("projectName").value;
      this.project.clientLogo = this.formData.get('clientLogo').value;
      this.project.logobase64 = this.logobase64;
    }
  }

  getFile(index) {


    if (
      this.uploads &&
      this.uploads.length &&
      this.uploads.find((ele) => ele.id === index)
    ) {
      const file = this.uploads.find((ele) => ele.id === index);
      return file ? file.fileName : "Choose file";
    } else if (
      index === this.attachmentTypes.clientLogo &&
      this.project.clientLogo
    ) {
      return this.project.projectName + ".png";
    } else if (index === this.attachmentTypes.ppt && this.project.fileURL) {
      return this.project.projectName + ".pptx";
    }
    return "Choose file";
  }
  
  
  saveData() {
    this.flag = true;
    this.loading = true;
    this.a = this.formData.getRawValue();
this.saveProjectDetails()
      }

  saveProjectDetails()
{
  this.isPurpose=false;
  this.isDescription=false;
  this.isTag=false;
   this.a = this.formData.getRawValue();
   for (const control of Object.keys(this.formData.controls)) {
    if (this.formData.controls[control].status == "INVALID") {
      return;
    }
  }
    if ((!(this.a.projectName && this.a.contentType && this.a.companyName
      && this.a.description && this.a.purposeOfUsage
      && this.a.contactPerson && this.a.tags
    ) && this.mode === 'add') || !(this.a.projectName && this.a.contentType && this.a.companyName
      && this.a.description && this.a.purposeOfUsage
      && this.a.contactPerson && this.a.tags
    ) && this.mode === 'edit') {

      return;
    }
    if(!this.filteredValues.find(s=>s.name==this.a.contactPerson))
      {
       
        this.formData.controls.contactPerson.setErrors({
          'pattern': true
        });
        return;
      }

      if (this.a.description &&this.a.description.trim() !== this.a.description) {
      this.isDescription=true;
        return;
      } 
      if (this.a.purposeOfUsage &&this.a.purposeOfUsage.trim() !== this.a.purposeOfUsage) {
        this.isPurpose=true;
          return;
        } 
        if (this.a.tags &&this.a.tags.trim() !== this.a.tags) {
          this.isTag=true;
            return;
          } 
    let deliveryOrganization = this.formData
      .get("companyName")
      .value.replace(/\s/g, "_");
    deliveryOrganization = deliveryOrganization.toLocaleUpperCase();

    if (this.uploads && this.uploads.length && this.filesChanged) {
      const projectCode = this.formData.get("projectName").value;
      for (let index = 0; index < this.uploads.length; index++) {
        if (this.uploads[index].id === AttachmentTypes.ppt) {
          this.uploads[index].fileName =
            deliveryOrganization + "/" + projectCode + `_ICT.pptx`;
        } else if (this.uploads[index].id === AttachmentTypes.clientLogo) {
          const logoExtension = this.uploads[index].file.name.substr(
            this.uploads[index].file.name.lastIndexOf(".") + 1
          );
          this.uploads[index].fileName =
            deliveryOrganization + "/" + projectCode + `.${logoExtension}`;
        }
      }
      this.projectService.saveFile(this.uploads).subscribe(
        (response) => {
          if (response) {
            this.addAttachmentToIndex(response);
          }
        },
        (error) => {
          this.loading = false;
          this.toastr.error(error.error);
        }
      );
    } else {
      this.addAttachmentToIndex();
    }
  }

  addAttachmentToIndex(uploads?: UploadFileResponse) {
    if (uploads !== undefined) {
      if (uploads.savedICTPPTPath) {
        this.project.fileURL = uploads.savedICTPPTPath;
      }
      if (uploads.savedLogoPath) {
        this.project.clientLogo = uploads.savedLogoPath;
        this.formData.controls.clientLogo.setValue(uploads.savedLogoPath);
      }
    }
    this.saveProject();
  }

  viewFile(url) {
    const dialogRef = this.matDialog.open(ViewfileComponent, {
      width: "900px",
      height: "500px",
      panelClass: "view-file",
      data: { iFrameURL: url, Method: "CaseStudies" },
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  saveProject() {
    this.loading = true;
    if (this.mode === "add") {
      const fileURL = this.project.fileURL;
      const projectId = this.project.projectId;
      this.project = this.formData.getRawValue();
      this.project.fileURL = fileURL;
      this.project.logobase64 = this.logobase64;
      this.project.projectId = projectId;
    } else {
      ;
      this.assignFromValues();
    }
    const tagFormValue = this.formData.get("tags").value;
    if (tagFormValue && typeof tagFormValue === "string") {
      if (tagFormValue.trim().length) {
        const tags = tagFormValue.split(",").map((item) => item.trim());
        this.project.tags = tags;
      }
    }
    if (this.mode === "add") {
      if (this.role !== "ContentManager" && this.role !== "Viewer") {
        this.insertICTProject();
      } else {
        // Notes can also be added.
        this.project.status = ProjectType.PendingDescription;
        this.project.projectId = this.project.projectName + this.create_UUID();
        this.insertICTProjectToHistory();
      }
    } else {
      if (
        this.role !== "ContentManager" &&
        this.role !== "Viewer" &&
        this.projectType !== "history"
      ) {
        this.updateICTProject();
      } else {
        if (
          this.project.status === ProjectType.RejectedDescription ||
          this.project.status === ProjectType.ApprovedDescription
        ) {
          if (this.rejectedToPendingSwitchFlag) {
            if (this.role !== "ContentManager") {
              this.insertICTProject("no");
              this.project.status = ProjectType.ApprovedDescription;
              this.insertICTProjectToHistory();
            } else {
              this.project.status = ProjectType.PendingDescription;
              this.insertICTProjectToHistory();
            }
          } else {
            if (this.project.status === ProjectType.ApprovedDescription) {
              this.project.version = ++this.project.version;
              this.updateICTProject();
              this.insertICTProjectToHistory();
            } else {
              this.insertICTProjectToHistory();
            }
          }
        } else {
          this.project.status = ProjectType.PendingDescription;
          this.ictProjectService.lockICTProject(this.project.id).subscribe(
            (res) => {
              if (res && res === true) {
                this.insertICTProjectToHistory();
              } else {
                this.loading = false;
                this.showDialog(
                  "Cannot update the project. Please contact your Administrator",
                  true,
                  "text-error"
                );
              }
            },
            (err) => {
              this.showDialog(
                "Cannot update the project. Please contact your Administrator",
                true,
                "text-error"
              );
            }
          );
        }

        // Show comments and make it for approve or reject
        // If approved send it to ictProjectIndex with making version increment by 1 and update with existing project Id  or create one.
        // If Rejected send it to ictPRojectHistoryIndex keep status reject and update projectHistoryIndex
      }
    }
  }
  create_UUID() {
    let dt = new Date().getTime();
    let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        // tslint:disable-next-line: no-bitwise
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        // tslint:disable-next-line: no-bitwise
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    return uuid;
  }

  updateChanges() { }

  updateICTProject() {
    this.ictProjectService.updateICTProject(this.project).subscribe((res) => {
      this.toastr.success("Project Updated Successfully");      
      setTimeout(() => {
        this.cancel()
       }, 100);
    });
  }

  updateICTProjectHistory() {
    this.toastr.success("Project Updated Successfully");

  }

  insertICTProjectToHistory() {
    if (this.mode === "add") {
      this.project.createdBy = this.auth.getEmailId();
    }
    this.project.updatedBy = this.auth.getEmailId();

    this.ictProjectService.insertProjectToHistory(this.project).subscribe(
      (res) => {
        this.loading = false;
        if (this.project.status === ProjectType.RejectedDescription) {
          this.toastr.error(
            "Project added to Rejected list");
        } else if (this.project.status === ProjectType.ApprovedDescription) {
          this.toastr.success("Project uploaded Successfully");
        } else {
          this.toastr.success(
            "Project added to Pending list");
        }
      },
      (err) => {
        this.toastr.error(
          "Some Error occured. Please try again later or contact your administrator"
        );
      }
    );
  }

  insertICTProject(showDialog?: any) {
    if (this.mode === "add") {
      this.project.createdBy = this.auth.getEmailId();
    }
    this.project.updatedBy = this.auth.getEmailId();

    this.ictProjectService.insertProject(this.project).subscribe(
      (res) => {
      
        this.loading = false;
        if(!res)
          {
            this.toastr.error(`Project with the name "${this.a.projectName}" already exists`);
            return;
    
          }
       else if (showDialog !== "no") {
          this.toastr.success(
            "Project Submitted Successfully"
          );
           this.cancel()
        }
      },
      (err) => {
        this.toastr.error(err);
        this.loading = false;
      }
    );
  }

  showCommentsDialog(isApproved) {
    this.matDialog
      .open(CommentsDialogComponent, { data: { isApproved: isApproved } })
      .afterClosed()
      .toPromise()
      .then((response) => {
        if (response) {
          if (isApproved) {
            this.project.status = ProjectType.ApprovedDescription;
            this.project.approvedBy = this.auth.getEmailId();
          } else {
            this.project.status = ProjectType.RejectedDescription;
          }
          if (!this.project.notes) {
            this.project.notes = [];
          }
          const note = new Notes();
          note.createdOn = new Date();
          note.createdBy = this.auth.getEmailId();
          note.description = response;
          this.project.notes.push(note);
          this.saveProject();
        }
      });
  }

  showDialog(message, navigateBack?, font?) {
    this.matDialog
      .open(InfoDialogComponent, {
        width: "280px",
        data: { message: message, class: font ? font : "text-danger" },
      })
      .afterClosed()
      .subscribe((res) => {
        if (navigateBack) {
          this.location.back();
        }
      });
  }

  cancel() {
    this.location.back();
  }

  getTimeSince(date) {
    const seconds = Math.floor(
      (new Date().getTime() - new Date(date).getTime()) / 1000
    );
    let interval = Math.floor(seconds / 31536000);

    if (interval > 1) {
      return interval + " years";
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
      return interval + " months";
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return interval + " days";
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return interval + " hours";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return interval + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  }
}
